import { useEffect } from "react";
import { useAuthStatus, useAuthUser } from "./session";
import { logger } from "../services/telemetry";
import { identifyUser } from "../analytics/tracking";

/* Syncs the authenticated user into telemetry (OTel logs) and product
 * analytics (Amplitude identify + organization group). Rendered only when auth
 * is enabled (the session hooks require AuthSessionProvider above them), so it
 * lives inside AuthProvider rather than at the App root. */
export function AuthTelemetryBridge() {
  const { status } = useAuthStatus();
  const user = useAuthUser();

  useEffect(() => {
    if (status !== "authenticated" || !user) return;

    logger.setUser({ id: user.userId });
    identifyUser(user.userId, user.organizationId);
  }, [status, user]);

  return null;
}
